export const excelDateToJSDate = (serial) => {
  const baseDate = new Date("1899-12-30");
  const millisecondsPerDay = 24 * 60 * 60 * 1000;
  const date = new Date(baseDate.getTime() + serial * millisecondsPerDay);
  return date;
};
